import FlowActions from '../../actions/flow';
import FlowSource from '../../sources/flow';
import GraphSource from '../../sources/graph';
import GraphActions from '../../actions/graph';
import EditorActions from '../../actions/editor';

import { pathOr } from 'ramda';

/**
 * @param {Object} mapElement the sub flow map element meta data
 * @param {String} flowId
 * @param {String} tenantId
 * @param {String} editingToken
 * @param {String} authenticationToken
 * @description Opens a subflow inside a new tab
 */
const OpenSubflowTab = (mapElement, flowId, tenantId, editingToken, authenticationToken) => {

    // Capture the selected map elements metadata
    GraphSource.getMapElement(mapElement.id, flowId, editingToken, 'map', tenantId, authenticationToken)
        .then(({ subflow }) => {

            const subFlowId = pathOr(
                null,
                ['flowId', 'id'],
                subflow,
            );

            if (subFlowId) {

                // Sub flow may not exist in the flow store, so fetch it
                FlowSource.getLatest(subFlowId, tenantId, authenticationToken)
                    .then(({ developerName }) => {
                        FlowActions.openSubflow(subFlowId);
                        EditorActions.openFlow(subFlowId, developerName);
                        GraphActions.get(subFlowId, tenantId, authenticationToken);
                    });
            }
        });
};

export default OpenSubflowTab;
